module.exports = __webpack_public_path__ + "home-banner.45f1d958.jpg";